import { useMediaQuery, useTheme } from '@material-ui/core'
import PageMetaData from '@v4/utils/data/PageMetaData'
import useStyles from './Content.styles'

export const useContent = props => {
	const {
		direction,
		mobileDirection,
		video,
		text,
		buttonText,
		buttonAction,
		buttonLink,
		onTextClick,
		onButtonClick,
		extraShortcuts,
		textEditable,
		onTextChange,
		buttonTextConfig,
		textConfig,
		buttonTextEditable,
		onButtonTextChange,
		textKey,
		buttonTextKey,
	} = props

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const classes = useStyles(props)

	return [
		{
			classes,
			direction: PageMetaData.CONTENT_DIRECTION[isMobile ? mobileDirection : direction],
			video,
			isMobile,

			text,
			textConfig,
			buttonText,
			buttonTextConfig,
			buttonAction,
			buttonLink,
			extraShortcuts,
			textEditable,
			buttonTextEditable,
			textKey,
			buttonTextKey,
		},
		{
			handleTextClick: onTextClick,
			handleButtonClick: onButtonClick,
			handleTextChange: onTextChange,
			handleButtonTextChange: onButtonTextChange,
		},
	]
}
